import { Button, Container, Group, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import classes from "./ErrorPage.module.scss";

function ErrorPage() {
  const navigate = useNavigate();
  const handleReset = () => {
    navigate("/home");
    window.location.reload();
  };

  return (
    <>
      <Container className={classes.root}>
        <div className={classes.label}>Error</div>
        <Title className={classes.title}>
          An unexpected error has occurred
        </Title>
        <Text
          c="dimmed"
          size="lg"
          align="center"
          className={classes.description}>
          We apologize, but an unexpected error has occurred on our website. Our
          technical team is already working to resolve it. Please try refreshing
          the page or returning to the previous page. If the issue persists,
          contact our support team and provide details about when the error
          occurred. Thank you for your patience as we work to fix this.
        </Text>
        <Group justify="center">
          <Button onClick={handleReset} variant="subtle" size="md">
            Go back to home page
          </Button>
        </Group>
      </Container>
    </>
  );
}

export default ErrorPage;
